<template>
  <q-drawer
    v-model="model"
    :breakpoint="1200"
    show-if-above
    class="bg-blue-grey-10 text-white"
  >
    <q-list v-if="auth.isAuthenticated">
      <q-item-label header class="text-subtitle2 text-white">
        Welcome: {{ auth.user.display_name }}
      </q-item-label>
      <q-item-label header> Main Menu </q-item-label>
      <q-item
        :to="{ name: 'index' }"
        :active-class="activeClass"
        clickable
        tag="a"
      >
        <q-item-section avatar>
          <q-icon :name="`fas fa-home`" />
        </q-item-section>

        <q-item-section>
          <q-item-label>myLHS Home</q-item-label>
        </q-item-section>
      </q-item>
      <q-separator />
      <SystemMenuItems
        v-for="link in auth.menu_display"
        :key="link.title"
        :menu-item="link"
        :active-class="activeClass"
      />
      <q-item
        :to="{ name: 'auth-logout' }"
        clickable
        tag="a"
        class="text-negative"
      >
        <q-item-section avatar>
          <q-icon :name="`fas fa-door-closed`" />
        </q-item-section>

        <q-item-section>
          <q-item-label>Sign Out</q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
    <q-list v-else>
      <q-item-label header class="text-grey-8"> Main Menu </q-item-label>
      <system-menu-items
        v-for="link in auth.menu_display"
        :key="link.title"
        :menu-item="link"
      />
    </q-list>
    <q-separator />
    <div class="fixed-bottom-right q-ma-sm">v{{ $app.version }}</div>
  </q-drawer>
</template>

<script setup>
  const props = defineProps({
    modelValue: {
      type: Boolean,
      required: true,
    },
  });
  const emit = defineEmits(['update:modelValue']);
  const model = useModelWrapper(props, emit);

  const auth = useAuthStore();

  const activeClass = "bg-blue text-amber";
</script>

<style>

</style>